import { TextManager } from "Components/TextContext";
import { HealthWithoutSigningProduct } from "Store/interfaces/products/checkout/lifeProducts/HealthProduct";
import { isDefined } from "Utils/functions";
import { ProductDetail } from "../../interface";
import { getYesOrNoText } from "../utils";

export const healthWithoutSigningDetailsList = (
  product: HealthWithoutSigningProduct,
): ProductDetail[] => {
  const { getText } = TextManager;

  return [
    {
      name: getText("healthform.shorttitle.issmoker"),
      value: getYesOrNoText(product.healthQuestions?.isSmoker),
      hidden: !isDefined(product.healthQuestions),
      suppressHJ: true,
    },
  ];
};
